import React from 'lib/react';
import { EVButton, EVLocationSearchingTwoToneIcon, makeStyles } from 'lib/components';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import { useState, useEffect } from 'react';
import {
  CRYPTO_KEY, CRYPTO_IV, LEGACY_PORTAL_LINKS, HOST_URL,
} from 'constants/AppConstants';
import { encryptAndEncode } from 'utils/app.utils';
import { ADDRESS_VERIFICATION_ROUTE } from 'constants/RouteConstants';
import { useLocation, Link } from 'lib/router';
import { useSelector } from 'lib/redux';
import { featureFlagSelector, isRedirectExceptionOrgSelector } from 'utils/appSelectors.utils';
import * as featureFlags from 'constants/FeatureFlag.constants';

export const useStyles = makeStyles((theme) => ({
  identifyBtn: {
    width: '125px',
    backgroundColor: theme.evPalette.salt[100],
    borderColor: theme.evPalette.charcoal[300],
    padding: '4px 12px 4px 12px',
  },
  indentifyBtnLabel: {
    columnGap: '8px',
    padding: 0,
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '19px',
    textTransform: 'none',
  },
}));

function IdentifyButton({ reportId, signedReportId }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [encryptedReportID, setEncryptedReportID] = useState(null);
  const location = useLocation();
  const currentUrl = `${location.pathname}${location.search}`;

  const myevRefreshLegacyRedirectFlag = useSelector(featureFlagSelector(featureFlags.REDIRECT_ACTION_BUTTONS_TO_LEGACY_PORTAL));
  const isRedirectExceptionOrg = useSelector(isRedirectExceptionOrgSelector);

  useEffect(() => {
    let isMounted = true;

    encryptAndEncode(reportId, CRYPTO_KEY, CRYPTO_IV)
      .then((encryptedID) => isMounted && setEncryptedReportID(encryptedID));

    return () => { isMounted = false; };
  }, []);

  const buttonProps = (() => {
    if (myevRefreshLegacyRedirectFlag) {
      return ({
        href: LEGACY_PORTAL_LINKS.addressVerification + encryptedReportID,
        target: '_blank',
      });
    }

    const identifyPath = ADDRESS_VERIFICATION_ROUTE.replace(':reportId', encryptedReportID);
    const signatureQuery = signedReportId ? `?signature=${encodeURIComponent(signedReportId)}` : ''; // #genai

    if (isRedirectExceptionOrg) {
      return ({
        component: Link,
        to: `${identifyPath}${signatureQuery}`,
        state: { currentUrl },
      });
    }

    return ({
      href: HOST_URL + identifyPath + signatureQuery,
      target: '_blank',
    });
  })();

  return (
    <EVButton
      id={`identifyBtn-${reportId}`}
      variant="outlined"
      color="primary"
      className={classes.identifyBtn}
      classes={{ label: classes.indentifyBtnLabel }}
      onClick={(e) => e.stopPropagation()}
      {...buttonProps}
    >
      <EVLocationSearchingTwoToneIcon />
      {t('order_history__actions__identify')}
    </EVButton>
  );
}

IdentifyButton.propTypes = {
  reportId: PropTypes.number.isRequired,
  signedReportId: PropTypes.string,
};

IdentifyButton.defaultProps = {
  signedReportId: null,
};

export default IdentifyButton;
